<template>
  <div id="dashboard-page">
    <b-card>
        <h3>{{$route.name}}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item><router-link to="/vehicle-dashboard">Vehicle Dashboard</router-link></b-breadcrumb-item>
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="border-bottom"></div>
        <b-row>
          <b-col md="9">
              <b-row class="mt-3 mb-3">
                  <b-col md="3">
                      <b-form-select v-model="tableFilter.branch" :options="branchList" />
                  </b-col>
                  <b-col md="3">
                      <b-form-input :placeholder="'Search by plate'" v-model="tableFilter.plate" customQueryParamName="search" />
                  </b-col>
                  <b-col md="3">
                      <b-form-input :placeholder="'Search by merk'" v-model="tableFilter.merk" customQueryParamName="search" />
                  </b-col>
                  <b-col md="3">
                    <b-button variant="primary" class="btn-back float-left btn-custom" @click="doFilter"><font-awesome-icon icon="search"/></b-button>
                  </b-col>
              </b-row>
          </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-show="true" :no-actions="false" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['merk', 'plate', 'branch_uuid']">
        </paginated-table>
    </b-card>
    </div>
</template>

<script>
  import PaginatedTable from '@/components/PaginatedTable'
  export default {
    components: {
      PaginatedTable
    },
    data () {
      return {
        dataKey: 'vehicles',
        apiUrl: window.AppConfig.apiUrl + 'vehicle?status=1',
        branchList: [
          {
            value: null,
            text: 'All Branch'
          }
        ],
        columns: [
          {
            key: 'branch',
            sortable: true
          },
          {
            key: 'plate',
            sortable: true
          },
          {
            key: 'merk',
            sortable: true
          },
          {
            key: 'model',
            sortable: true
          },
          {
            key: 'statusVehicle',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: ''
          }
        ],
        tableFilter: {
          branch_uuid: this.$route.query.branch_uuid,
          branch: null,
          merk: this.$route.query.merk,
          plate: this.$route.query.plate
        }
      }
    },
    mounted() {
      this.getBranch()
    },
    methods: {
      doFilter () {
        this.tableFilter.plate = this.tableFilter.plate
        this.tableFilter.merk = this.tableFilter.merk
        this.tableFilter.branch_uuid = this.tableFilter.branch
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      getBranch () {
        this.$http.get(window.AppConfig.apiUrl + 'branch?limit=10000').then(resp => {
          resp.data._embedded.branch.forEach(data => {
            this.branchList.push({
                value: data.uuid,
                text: data.name
            })
          })
        })
      }
    }
  }
</script>
